module.exports = __webpack_public_path__ + "img/code.b3664878.jpg";